import { Category } from 'models/IntegrationsConfig'
import { buildTranslate } from '../locales'
import { integrationsCenterUrls } from './urlUtils'

const t = buildTranslate('integration_center')

const gamificationCategory: Category = {
  key: 'games',
  title: t('gamification.title'),
  description: null,
  helpUrl: null,
  integrations: [
    {
      key: 'brame',
      title: t('gamification.brame.title'),
      description: null,
      helpUrl: integrationsCenterUrls.help,
      emailSubject: t('gamification.emailSubject', {
        integration: t('gamification.brame.title'),
      }),
      partners: [],
    },
    {
      key: 'peek_poke',
      title: t('gamification.peekPoke.title'),
      description: null,
      helpUrl: integrationsCenterUrls.help,
      emailSubject: null,
      partners: [],
    },
  ],
}

const baseIntegrationsList: Array<Category> = [
  {
    key: 'pos_instore_sku_data',
    title: t('posInstoreSkuData.title'),
    description: null,
    helpUrl: null,
    integrations: [
      {
        description: null,
        title: t('posInstoreSkuData.toast.title'),
        key: 'toast',
        helpUrl: integrationsCenterUrls.posInstoreSkuData.toast,
        emailSubject: t('posInstoreSkuData.emailSubject', {
          pos: t('posInstoreSkuData.toast.title'),
        }),
        partners: [],
      },
      {
        key: 'revel',
        title: t('posInstoreSkuData.revel.title'),
        description: null,
        helpUrl: integrationsCenterUrls.posInstoreSkuData.revel,
        emailSubject: t('posInstoreSkuData.emailSubject', {
          pos: t('posInstoreSkuData.revel.title'),
        }),
        partners: [],
      },
      {
        key: 'olo_omnivore',
        title: t('posInstoreSkuData.oloOmnivore.title'),
        description: t('posInstoreSkuData.oloOmnivore.description'),
        helpUrl: integrationsCenterUrls.posInstoreSkuData.olo_omnivore,
        emailSubject: t('posInstoreSkuData.emailSubject', {
          pos: t('posInstoreSkuData.oloOmnivore.title'),
        }),
        partners: [],
      },
      {
        key: 'square',
        title: t('posInstoreSkuData.square.title'),
        description: null,
        helpUrl: integrationsCenterUrls.posInstoreSkuData.square,
        emailSubject: t('posInstoreSkuData.emailSubject', {
          pos: t('posInstoreSkuData.square.title'),
        }),
        partners: [],
      },
      {
        key: 'qu',
        title: t('posInstoreSkuData.qu.title'),
        description: null,
        helpUrl: integrationsCenterUrls.posInstoreSkuData.qu,
        emailSubject: t('posInstoreSkuData.emailSubject', {
          pos: t('posInstoreSkuData.qu.title'),
        }),
        partners: [],
      },
      {
        key: 'ncr',
        title: t('posInstoreSkuData.ncr.title'),
        description: null,
        helpUrl: integrationsCenterUrls.posInstoreSkuData.ncr,
        emailSubject: t('posInstoreSkuData.emailSubject', {
          pos: t('posInstoreSkuData.ncr.title'),
        }),
        partners: [],
      },
      {
        key: 'par_brink_sku',
        title: t('posInstoreSkuData.parBrink.title'),
        description: null,
        helpUrl: integrationsCenterUrls.posInstoreSkuData.par_brink,
        emailSubject: t('posInstoreSkuData.emailSubject', {
          pos: t('posInstoreSkuData.parBrink.title'),
        }),
        partners: [],
        comingSoon: true,
      },
    ],
  },
  {
    key: 'pos_instore_offer_management',
    title: t('posInstoreOfferManagement.title'),
    helpUrl: null,
    description: null,
    integrations: [
      {
        key: 'thanx',
        title: t('posInstoreOfferManagement.thanx.title'),
        description: t('posInstoreOfferManagement.thanx.description'),
        helpUrl: null,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'toast',
        title: t('posInstoreOfferManagement.toast.title'),
        description: null,
        helpUrl: integrationsCenterUrls.posInstoreOfferManagement.toast,
        emailSubject: t('posInstoreOfferManagement.emailSubject', {
          pos: t('posInstoreOfferManagement.toast.title'),
        }),
        partners: [],
      },
      {
        key: 'fishbowl',
        title: t('posInstoreOfferManagement.fishbowl.title'),
        description: t('posInstoreOfferManagement.fishbowl.description'),
        helpUrl: integrationsCenterUrls.posInstoreOfferManagement.fishbowl,
        emailSubject: t('posInstoreOfferManagement.emailSubject', {
          pos: t('posInstoreOfferManagement.fishbowl.title'),
        }),
        partners: [],
      },
      {
        key: 'ncr',
        title: t('posInstoreOfferManagement.ncr.title'),
        description: null,
        helpUrl: integrationsCenterUrls.posInstoreOfferManagement.ncr,
        emailSubject: t('posInstoreOfferManagement.emailSubject', {
          pos: t('posInstoreOfferManagement.ncr.title'),
        }),
        partners: [],
      },
      {
        key: 'qu',
        title: t('posInstoreOfferManagement.qu.title'),
        description: null,
        helpUrl: integrationsCenterUrls.posInstoreOfferManagement.qu,
        emailSubject: t('posInstoreOfferManagement.emailSubject', {
          pos: t('posInstoreOfferManagement.qu.title'),
        }),
        partners: [],
      },
      {
        key: 'square',
        title: t('posInstoreOfferManagement.square.title'),
        description: null,
        helpUrl: integrationsCenterUrls.posInstoreOfferManagement.square,
        emailSubject: t('posInstoreOfferManagement.emailSubject', {
          pos: t('posInstoreOfferManagement.square.title'),
        }),
        partners: [],
      },
      {
        key: 'shift4',
        title: t('posInstoreOfferManagement.shift4.title'),
        description: null,
        helpUrl: integrationsCenterUrls.posInstoreOfferManagement.shift4,
        emailSubject: t('posInstoreOfferManagement.emailSubject', {
          pos: t('posInstoreOfferManagement.shift4.title'),
        }),
        partners: [],
      },
      {
        key: 'par_brink',
        title: t('posInstoreOfferManagement.parBrink.title'),
        description: null,
        helpUrl: integrationsCenterUrls.posInstoreOfferManagement.par_brink,
        emailSubject: t('posInstoreOfferManagement.emailSubject', {
          pos: t('posInstoreOfferManagement.parBrink.title'),
        }),
        partners: [],
        comingSoon: true,
      },
      {
        key: 'franpos',
        title: t('posInstoreOfferManagement.franpos.title'),
        description: null,
        helpUrl: integrationsCenterUrls.posInstoreOfferManagement.franpos,
        emailSubject: t('posInstoreOfferManagement.emailSubject', {
          pos: t('posInstoreOfferManagement.franpos.title'),
        }),
        partners: [],
        comingSoon: true,
      },
      {
        key: 'tabit',
        title: t('posInstoreOfferManagement.tabit.title'),
        description: null,
        helpUrl: integrationsCenterUrls.posInstoreOfferManagement.tabit,
        emailSubject: t('posInstoreOfferManagement.emailSubject', {
          pos: t('posInstoreOfferManagement.tabit.title'),
        }),
        partners: [],
        comingSoon: true,
      },
      {
        key: 'genius_xenial',
        title: t('posInstoreOfferManagement.geniusXenial.title'),
        description: null,
        helpUrl: integrationsCenterUrls.posInstoreOfferManagement.genius_xenial,
        emailSubject: t('posInstoreOfferManagement.emailSubject', {
          pos: t('posInstoreOfferManagement.geniusXenial.title'),
        }),
        partners: [],
        comingSoon: true,
      },
    ],
  },
  {
    key: 'digital_order_management',
    title: t('digitalOrderManagement.title'),
    description: t('digitalOrderManagement.description'),
    helpUrl: null,
    integrations: [
      {
        key: 'olo',
        title: t('digitalOrderManagement.olo.title'),
        description: null,
        helpUrl: integrationsCenterUrls.digital_order_management.olo,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'toast',
        title: t('digitalOrderManagement.toast.title'),
        description: null,
        helpUrl: integrationsCenterUrls.digital_order_management.toast,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'open_tender',
        title: t('digitalOrderManagement.openTender.title'),
        description: null,
        helpUrl: integrationsCenterUrls.digital_order_management.open_tender,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'cardfree',
        title: t('digitalOrderManagement.cardfree.title'),
        description: null,
        helpUrl: null,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'deliverect',
        title: t('digitalOrderManagement.deliverect.title'),
        description: null,
        helpUrl: null,
        emailSubject: null,
        partners: [],
        comingSoon: true,
      },
      {
        key: 'square_digital',
        title: t('digitalOrderManagement.square.title'),
        description: null,
        helpUrl: null,
        emailSubject: null,
        partners: [],
        comingSoon: true,
      },
      {
        key: 'onosys',
        title: t('digitalOrderManagement.onosys.title'),
        description: null,
        helpUrl: null,
        emailSubject: null,
        partners: [],
        comingSoon: true,
      },
    ],
  },
  {
    key: 'delivery',
    title: t('delivery.title'),
    helpUrl: null,
    description: null,
    integrations: [
      {
        key: 'olo_dispatch',
        title: t('delivery.oloDispatch.title'),
        description: t('managed_by_olo'),
        helpUrl: integrationsCenterUrls.delivery.olo_dispatch,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'doordash',
        title: t('delivery.doordash.title'),
        description: t('managed_via_thanx'),
        helpUrl: integrationsCenterUrls.delivery.doordash,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'uber',
        title: t('delivery.uber.title'),
        description: null,
        helpUrl: integrationsCenterUrls.delivery.doordash,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'vromo',
        title: t('delivery.vromo.title'),
        description: null,
        helpUrl: integrationsCenterUrls.delivery.vromo,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'cartwheel',
        title: t('delivery.cartwheel.title'),
        description: null,
        helpUrl: integrationsCenterUrls.help,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'deliverect_delivery',
        title: t('delivery.deliverect.title'),
        description: null,
        helpUrl: integrationsCenterUrls.help,
        emailSubject: null,
        partners: [],
        comingSoon: true,
      },
    ],
  },
  {
    key: 'database_destinations',
    title: t('databaseDestinations.title'),
    description: null,
    helpUrl: null,
    integrations: [
      {
        key: 'mysql',
        title: t('databaseDestinations.mysql.title'),
        description: null,
        helpUrl: integrationsCenterUrls.databaseDestinations,
        emailSubject: t('databaseDestinations.emailSubject', {
          integration: t('databaseDestinations.mysql.title'),
        }),
        partners: [],
      },
      {
        key: 'postgresql',
        title: t('databaseDestinations.postgresql.title'),
        description: null,
        helpUrl: integrationsCenterUrls.databaseDestinations,
        emailSubject: t('databaseDestinations.emailSubject', {
          integration: t('databaseDestinations.postgresql.title'),
        }),
        partners: [],
      },
      {
        key: 'mariadb',
        title: t('databaseDestinations.mariadb.title'),
        description: null,
        helpUrl: integrationsCenterUrls.databaseDestinations,
        emailSubject: t('databaseDestinations.emailSubject', {
          integration: t('databaseDestinations.mariadb.title'),
        }),
        partners: [],
      },
      {
        key: 'mongodb',
        title: t('databaseDestinations.mongodb.title'),
        description: null,
        helpUrl: integrationsCenterUrls.databaseDestinations,
        emailSubject: t('databaseDestinations.emailSubject', {
          integration: t('databaseDestinations.mongodb.title'),
        }),
        partners: [],
      },
      {
        key: 'oracle',
        title: t('databaseDestinations.oracle.title'),
        description: null,
        helpUrl: integrationsCenterUrls.databaseDestinations,
        emailSubject: t('databaseDestinations.emailSubject', {
          integration: t('databaseDestinations.oracle.title'),
        }),
        partners: [],
      },
      {
        key: 'sql_server',
        title: t('databaseDestinations.sqlServer.title'),
        description: null,
        helpUrl: integrationsCenterUrls.databaseDestinations,
        emailSubject: t('databaseDestinations.emailSubject', {
          integration: t('databaseDestinations.sqlServer.title'),
        }),
        partners: [],
      },
      {
        key: 'aurora_mysql',
        title: t('databaseDestinations.auroraMysql.title'),
        description: null,
        helpUrl: integrationsCenterUrls.databaseDestinations,
        emailSubject: t('databaseDestinations.emailSubject', {
          integration: t('databaseDestinations.auroraMysql.title'),
        }),
        partners: [],
      },
      {
        key: 'aurora_postgresql',
        title: t('databaseDestinations.auroraPostgresql.title'),
        description: null,
        helpUrl: integrationsCenterUrls.databaseDestinations,
        emailSubject: t('databaseDestinations.emailSubject', {
          integration: t('databaseDestinations.auroraPostgresql.title'),
        }),
        partners: [],
      },
      {
        key: 'singlestore',
        title: t('databaseDestinations.singlestore.title'),
        description: null,
        helpUrl: integrationsCenterUrls.databaseDestinations,
        emailSubject: t('databaseDestinations.emailSubject', {
          integration: t('databaseDestinations.singlestore.title'),
        }),
        partners: [],
      },
    ],
  },
  {
    key: 'thanx_connex',
    title: t('thanxConnex.title'),
    description: null,
    helpUrl: null,
    integrations: [
      {
        key: 'big_query',
        title: t('thanxConnex.bigQuery.title'),
        description: null,
        helpUrl: integrationsCenterUrls.thanxConnex,
        emailSubject: t('thanxConnex.emailSubject', {
          integration: t('thanxConnex.bigQuery.title'),
        }),
        partners: [],
      },
      {
        key: 'clickhouse',
        title: t('thanxConnex.clickhouse.title'),
        description: null,
        helpUrl: integrationsCenterUrls.thanxConnex,
        emailSubject: t('thanxConnex.emailSubject', {
          integration: t('thanxConnex.clickhouse.title'),
        }),
        partners: [],
      },
      {
        key: 'databricks',
        title: t('thanxConnex.databricks.title'),
        description: null,
        helpUrl: integrationsCenterUrls.thanxConnex,
        emailSubject: t('thanxConnex.emailSubject', {
          integration: t('thanxConnex.databricks.title'),
        }),
        partners: [],
      },
      {
        key: 'athena',
        title: t('thanxConnex.athena.title'),
        description: null,
        helpUrl: integrationsCenterUrls.thanxConnex,
        emailSubject: t('thanxConnex.emailSubject', {
          integration: t('thanxConnex.athena.title'),
        }),
        partners: [],
      },
      {
        key: 'firebolt',
        title: t('thanxConnex.firebolt.title'),
        description: null,
        helpUrl: integrationsCenterUrls.thanxConnex,
        emailSubject: t('thanxConnex.emailSubject', {
          integration: t('thanxConnex.firebolt.title'),
        }),
        partners: [],
      },
      {
        key: 'materialize',
        title: t('thanxConnex.materialize.title'),
        description: null,
        helpUrl: integrationsCenterUrls.thanxConnex,
        emailSubject: t('thanxConnex.emailSubject', {
          integration: t('thanxConnex.materialize.title'),
        }),
        partners: [],
      },
      {
        key: 'redshift',
        title: t('thanxConnex.redshift.title'),
        description: null,
        helpUrl: integrationsCenterUrls.thanxConnex,
        emailSubject: t('thanxConnex.emailSubject', {
          integration: t('thanxConnex.redshift.title'),
        }),
        partners: [],
      },
      {
        key: 'snowflake',
        title: t('thanxConnex.snowflake.title'),
        description: null,
        helpUrl: integrationsCenterUrls.thanxConnex,
        emailSubject: t('thanxConnex.emailSubject', {
          integration: t('thanxConnex.snowflake.title'),
        }),
        partners: [],
      },
    ],
  },
  {
    key: 'kiosks_pay_at_table',
    title: t('kiosksPayAtTable.title'),
    description: null,
    helpUrl: null,
    integrations: [
      {
        key: 'bite',
        title: t('kiosksPayAtTable.bite.title'),
        description: null,
        helpUrl: integrationsCenterUrls.kiosksPayAtTable,
        emailSubject: t('kiosksPayAtTable.emailSubject', {
          integration: t('kiosksPayAtTable.bite.title'),
        }),
        partners: [],
      },
      {
        key: 'grubbrr',
        title: t('kiosksPayAtTable.grubbrr.title'),
        description: null,
        helpUrl: integrationsCenterUrls.kiosksPayAtTable,
        emailSubject: t('kiosksPayAtTable.emailSubject', {
          integration: t('kiosksPayAtTable.grubbrr.title'),
        }),
        partners: [],
      },
      {
        key: 'toast_kiosk',
        title: t('kiosksPayAtTable.toast.title'),
        description: null,
        helpUrl: integrationsCenterUrls.kiosksPayAtTable,
        emailSubject: t('kiosksPayAtTable.emailSubject', {
          integration: t('kiosksPayAtTable.toast.title'),
        }),
        partners: [],
      },
      {
        key: 'upn_go',
        title: t('kiosksPayAtTable.upnGo.title'),
        description: null,
        helpUrl: integrationsCenterUrls.kiosksPayAtTable,
        emailSubject: null,
        partners: [],
        comingSoon: true,
      },
      {
        key: 'sunday',
        title: t('kiosksPayAtTable.sunday.title'),
        description: null,
        helpUrl: integrationsCenterUrls.kiosksPayAtTable,
        emailSubject: null,
        partners: [],
        comingSoon: true,
      },
    ],
  },
  {
    key: 'cdp',
    title: t('cdp.title'),
    description: null,
    helpUrl: null,
    integrations: [
      {
        key: 'olo_gdp',
        title: t('cdp.oloGdp.title'),
        description: null,
        helpUrl: integrationsCenterUrls.cdp.olo_gdp,
        emailSubject: t('cdp.emailSubject', { cdp: t('cdp.oloGdp.title') }),
        partners: [],
      },
      {
        key: 'bikky',
        title: t('cdp.bikky.title'),
        description: null,
        helpUrl: integrationsCenterUrls.cdp.bikky,
        emailSubject: t('cdp.emailSubject', { cdp: t('cdp.bikky.title') }),
        partners: [],
        comingSoon: true,
      },
      {
        key: 'delightable',
        title: t('cdp.delightable.title'),
        description: null,
        helpUrl: integrationsCenterUrls.cdp.delightable,
        emailSubject: t('cdp.emailSubject', {
          cdp: t('cdp.delightable.title'),
        }),
        partners: [],
      },
      {
        key: 'customerxi',
        title: t('cdp.customerxi.title'),
        description: null,
        helpUrl: null,
        emailSubject: t('cdp.emailSubject', {
          cdp: t('cdp.customerxi.title'),
        }),
        partners: [],
        comingSoon: true,
      },
    ],
  },
  {
    key: 'email_marketing',
    title: t('emailMarketing.title'),
    description: t('emailMarketing.description'),
    helpUrl: null,
    integrations: [
      {
        key: 'thanx',
        title: t('emailMarketing.thanx.title'),
        description: t('emailMarketing.thanx.description'),
        helpUrl: integrationsCenterUrls.emailMarketing.thanx,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'klaviyo',
        title: t('emailMarketing.klaviyo.title'),
        description: null,
        helpUrl: integrationsCenterUrls.emailMarketing.klaviyo,
        emailSubject: t('emailMarketing.emailSubject', {
          integration: t('emailMarketing.klaviyo.title'),
        }),
        partners: [],
      },
      {
        key: 'braze',
        title: t('emailMarketing.braze.title'),
        description: null,
        helpUrl: integrationsCenterUrls.emailMarketing.braze,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'olo_gdp',
        title: t('emailMarketing.oloGdp.title'),
        description: null,
        helpUrl: integrationsCenterUrls.emailMarketing.olo_gdp,
        emailSubject: t('emailMarketing.emailSubject', {
          integration: t('emailMarketing.oloGdp.title'),
        }),
        partners: [],
      },
      {
        key: 'fishbowl',
        title: t('emailMarketing.fishbowl.title'),
        description: null,
        helpUrl: integrationsCenterUrls.emailMarketing.fishbowl,
        emailSubject: t('emailMarketing.emailSubject', {
          integration: t('emailMarketing.fishbowl.title'),
        }),
        partners: [],
      },
      {
        key: 'attentive',
        title: t('emailMarketing.attentive.title'),
        description: null,
        helpUrl: integrationsCenterUrls.emailMarketing.attentive,
        emailSubject: t('emailMarketing.emailSubject', {
          integration: t('emailMarketing.attentive.title'),
        }),
        partners: [],
      },
      {
        key: 'olo_engage',
        title: t('emailMarketing.oloEngage.title'),
        description: null,
        helpUrl: integrationsCenterUrls.emailMarketing.olo_engage,
        emailSubject: t('emailMarketing.emailSubject', {
          integration: t('emailMarketing.oloEngage.title'),
        }),
        partners: [],
      },
    ],
  },
  {
    key: 'sms_marketing',
    title: t('smsMarketing.title'),
    description: t('smsMarketing.description'),
    helpUrl: null,
    integrations: [
      {
        key: 'thanx',
        title: t('smsMarketing.thanx.title'),
        description: t('smsMarketing.thanx.description'),
        helpUrl: integrationsCenterUrls.smsMarketing.thanx,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'klaviyo',
        title: t('smsMarketing.klaviyo.title'),
        description: null,
        helpUrl: integrationsCenterUrls.smsMarketing.klaviyo,
        emailSubject: t('smsMarketing.emailSubject', {
          integration: t('smsMarketing.klaviyo.title'),
        }),
        partners: [],
        comingSoon: true,
      },
      {
        key: 'attentive',
        title: t('smsMarketing.attentive.title'),
        description: null,
        helpUrl: integrationsCenterUrls.help,
        emailSubject: t('smsMarketing.emailSubject', {
          integration: t('smsMarketing.attentive.title'),
        }),
        partners: [],
      },
    ],
  },
  {
    key: 'marketing_automation_wifi',
    title: t('marketingAutomationWifi.title'),
    description: null,
    helpUrl: null,
    integrations: [
      {
        key: 'adentro',
        title: t('marketingAutomationWifi.adentro.title'),
        description: t('marketingAutomationWifi.adentro.description'),
        helpUrl: integrationsCenterUrls.help,
        emailSubject: t('marketingAutomationWifi.emailSubject', {
          integration: t('marketingAutomationWifi.adentro.title'),
        }),
        partners: [],
      },
      {
        key: 'gozone',
        title: t('marketingAutomationWifi.gozone.title'),
        description: null,
        helpUrl: null,
        emailSubject: t('marketingAutomationWifi.emailSubject', {
          integration: t('marketingAutomationWifi.gozone.title'),
        }),
        partners: [],
      },
    ],
  },
  {
    key: 'feedback',
    title: t('feedback.title'),
    description: t('feedback.description'),
    helpUrl: integrationsCenterUrls.feedback.thanx,
    integrations: [
      {
        key: 'thanx',
        title: t('feedback.thanx.title'),
        description: t('feedback.thanx.description'),
        helpUrl: integrationsCenterUrls.feedback.thanx,
        emailSubject: t('feedback.emailSubject', {
          integration: t('feedback.thanx.title'),
        }),
        partners: [],
      },
      {
        key: 'tattle',
        title: t('feedback.tattle.title'),
        description: null,
        helpUrl: integrationsCenterUrls.feedback.tattle,
        emailSubject: t('feedback.emailSubject', {
          integration: t('feedback.tattle.title'),
        }),
        partners: [],
      },
      {
        key: 'ovation',
        title: t('feedback.ovation.title'),
        description: null,
        helpUrl: integrationsCenterUrls.feedback.ovation,
        emailSubject: t('feedback.emailSubject', {
          integration: t('feedback.ovation.title'),
        }),
        partners: [],
      },
      {
        key: 'yumpingo',
        title: t('feedback.yumpingo.title'),
        description: null,
        helpUrl: integrationsCenterUrls.help,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'guestxm',
        title: t('feedback.guestxm.title'),
        description: null,
        helpUrl: integrationsCenterUrls.help,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'momos',
        title: t('feedback.momos.title'),
        description: null,
        helpUrl: integrationsCenterUrls.help,
        emailSubject: null,
        partners: [],
      },
      {
        key: 'black_box_intelligence',
        title: t('feedback.blackBoxIntelligence.title'),
        description: null,
        helpUrl: integrationsCenterUrls.help,
        emailSubject: null,
        partners: [],
      },
    ],
  },
  {
    key: 'custom_data_capture',
    title: t('customDataCapture.title'),
    helpUrl: null,
    description: null,
    integrations: [
      {
        key: 'jotform',
        title: t('customDataCapture.jotform.title'),
        description: null,
        helpUrl: integrationsCenterUrls.help,
        emailSubject: t('customDataCapture.emailSubject', {
          integration: t('customDataCapture.jotform.title'),
        }),
        partners: [],
      },
    ],
  },
  {
    key: 'location_intelligence',
    title: t('locationIntelligence.title'),
    helpUrl: null,
    description: null,
    integrations: [
      {
        key: 'flybuy',
        title: t('locationIntelligence.flybuy.title'),
        description: null,
        helpUrl: integrationsCenterUrls.help,
        emailSubject: t('locationIntelligence.emailSubject', {
          integration: t('locationIntelligence.flybuy.title'),
        }),
        partners: [],
      },
    ],
  },
  {
    key: 'stored_value',
    title: t('storedValue.title'),
    helpUrl: null,
    description: null,
    integrations: [
      {
        key: 'ansa',
        title: t('storedValue.ansa.title'),
        description: null,
        helpUrl: integrationsCenterUrls.storedValue.ansa,
        emailSubject: null,
        partners: [],
      },
    ],
  },
  {
    key: 'business_intelligence',
    title: t('businessIntelligence.title'),
    description: null,
    helpUrl: null,
    integrations: [
      {
        key: 'bikky_bi',
        title: t('businessIntelligence.bikky.title'),
        description: null,
        helpUrl: integrationsCenterUrls.businessIntelligence.bikky,
        emailSubject: t('businessIntelligence.emailSubject', {
          integration: t('businessIntelligence.bikky.title'),
        }),
        partners: [],
      },
      {
        key: 'rad',
        title: t('businessIntelligence.rad.title'),
        description: null,
        helpUrl: null,
        emailSubject: t('businessIntelligence.emailSubject', {
          integration: t('businessIntelligence.rad.title'),
        }),
        partners: [],
      },
      {
        key: 'ingest_ai',
        title: t('businessIntelligence.ingestAi.title'),
        description: null,
        helpUrl: null,
        emailSubject: t('businessIntelligence.emailSubject', {
          integration: t('businessIntelligence.ingestAi.title'),
        }),
        partners: [],
        comingSoon: true,
      },
    ],
  },
  {
    key: 'in_store_audio',
    title: t('inStoreAudio.title'),
    description: null,
    helpUrl: null,
    integrations: [
      {
        key: 'custom_channels',
        title: t('inStoreAudio.customChannels.title'),
        description: null,
        helpUrl: null,
        emailSubject: t('inStoreAudio.emailSubject', {
          integration: t('inStoreAudio.customChannels.title'),
        }),
        partners: [],
        comingSoon: true,
      },
    ],
  },
  {
    key: 'gift_card',
    title: t('giftCard.title'),
    helpUrl: null,
    description: null,
    integrations: [
      {
        key: 'valutec',
        title: t('giftCard.valutec.title'),
        description: null,
        helpUrl: integrationsCenterUrls.giftCard.valutec,
        emailSubject: null,
        partners: [],
      },
    ],
  },
]

const brinkKeys: Array<string> = ['par_brink', 'par_brink_sku']

const removeBrinkComingSoon = (list: Array<Category>): Array<Category> =>
  list.map(category => ({
    ...category,
    integrations: category.integrations.map(integration =>
      brinkKeys.includes(integration.key)
        ? { ...integration, comingSoon: undefined }
        : integration
    ),
  }))

export const getIntegrationsList = (
  gamificationEnabled = false,
  brinkIntegrationEnabled = false
): Array<Category> => {
  let list = gamificationEnabled
    ? [gamificationCategory, ...baseIntegrationsList]
    : baseIntegrationsList

  if (brinkIntegrationEnabled) {
    list = removeBrinkComingSoon(list)
  }

  return list
}

// Keep the original export for backward compatibility
export const integrationsList: Array<Category> = baseIntegrationsList
